import { BodyText } from '@policygenius/mortar';
import { useState } from 'react';
import { FormRenderProps } from 'react-final-form';
import { createUseStyles } from 'react-jss';

import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import { InitialValues } from 'forms/types';

import {
  MAIN_COPY_1,
  MAIN_COPY_2,
  NONCANCELLABLE_EXPLAINER,
  NONCANCELLABLE_LABEL,
  OWN_OCCUPATION_POLICY_EXPLAINER,
  OWN_OCCUPATION_POLICY_LABEL,
  RESIDUAL_DISABILITY_POLICY_EXPLAINER,
  RESIDUAL_DISABILITY_POLICY_LABEL,
} from './constants';
import Explainer from './Explainer';
import LearnMoreModal from './LearnMoreModal';
import styles from './styles';
import { PolicyFeaturesFormValues } from './types';

const useStyles = createUseStyles(styles);

const PolicyFeaturesForm: React.FC<
  FormRenderProps<PolicyFeaturesFormValues, InitialValues<PolicyFeaturesFormValues>>
> = ({ handleSubmit, invalid, submitting }) => {
  const classes = useStyles();
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);

  const onLearnMore = () => setShowLearnMoreModal(true);

  return (
    <>
      <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
        <BodyText className={classes.mainCopy} size="large">
          <BodyText as="strong" size="inherit" weight="bold">
            {MAIN_COPY_1}
          </BodyText>{' '}
          {MAIN_COPY_2}
        </BodyText>
        <ToggleField groupLabel={OWN_OCCUPATION_POLICY_LABEL} name="ownOccupationPolicy" />
        <Explainer text={OWN_OCCUPATION_POLICY_EXPLAINER} onLearnMore={onLearnMore} />
        <ToggleField
          groupLabel={RESIDUAL_DISABILITY_POLICY_LABEL}
          name="residualDisabilityPolicy"
        />
        <Explainer text={RESIDUAL_DISABILITY_POLICY_EXPLAINER} onLearnMore={onLearnMore} />
        <ToggleField groupLabel={NONCANCELLABLE_LABEL} name="noncancellable" />
        <Explainer text={NONCANCELLABLE_EXPLAINER} />
      </FormWrapper>
      <LearnMoreModal showModal={showLearnMoreModal} setShowModal={setShowLearnMoreModal} />
    </>
  );
};

export default PolicyFeaturesForm;
